import { http } from '@/plugins/http'
import { SET_LAST_SEARCH_RESULT } from '../mutationTypes'
import { normalize, schema } from 'normalizr'
import { checkStatus, getHeaders, parseJSON, buildUrlWithQuery } from '../../utils/api'

const state = {
  lastSearchResult: {}
}

const actions = {
  searchWithQuery (store, payload) {
    const { endpoint, query } = payload
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    return http.get(buildUrlWithQuery(endpoint, query, instanceUrl), { headers })
      .then(checkStatus)
      .then(parseJSON)
      .then(r => {
        if (!r.hasOwnProperty('results')) return Promise.reject('Error fetching search results')
        const { count, results } = r
        const searchResultSchema = new schema.Entity(endpoint)
        const searchResultListSchema = new schema.Array(searchResultSchema)
        const { entities, result } = normalize(results, searchResultListSchema)
        if (!result || !Array.isArray(result)) return Promise.reject('Error normalizing response')
        this.commit(SET_LAST_SEARCH_RESULT, entities)
        return { query, count, entities }
      })
      .catch(e => {
        console.log(e)
        return e
      })
  },
  storeLastSearchResults (store, payload) {
    const { entityType, mutation } = payload
    let data
    if (entityType) {
      data = store.getters.getLastSearchResult[entityType]
    }
    if (data && Object.keys(data).length) {
      this.commit(mutation, { next: null, data })
    }
  }
}

const getters = {
  getLastSearchResult: (state) => {
    return state.lastSearchResult || {}
  }
}

const mutations = {
  [SET_LAST_SEARCH_RESULT] (state, payload) {
    state.lastSearchResult = Object.assign({}, payload)
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
